import layout from '@/layout';
import routerMap from '../routerMap.js';

const meta = { auth: true };
export default{
  path: '/platform',
  name: 'platform', 
  meta:{...meta,title:"平台管理",hidden:true},
  component: layout,
  children: ((pre,prePath) => [ 
    { path: `${prePath}resource/resourcemanage`, name: `${pre}resource-resourcemanage`, component:routerMap.platform_resourceperm_resource_query, meta: { ...meta, title: '资源管理',keepAlive:true,clearCache:false }},
    { path: `${prePath}tenant/tenManage`, name: `${pre}tenant-tenmanage`, component:routerMap.platform_tanant_query, meta: { ...meta, title: '租户管理',keepAlive:true,clearCache:false }},
    { path: `${prePath}tenant/freezepage`, name: `${pre}tenant-freezepage`, component:routerMap.platform_tanant_freeze, meta: { ...meta, title: '授权管理',keepAlive:true,clearCache:false }}
  ])('platform-','/platform/')
}